const menuToggle = document.querySelector('#menu-toggle');
const mobileNav = document.querySelector('#mobile-nav');
const searchToggle = document.querySelector('#search-toggle');
const searchPanel = document.querySelector('#search-panel');
const searchInput = document.querySelector('#product-search');
function closeMenu(){mobileNav.hidden=true;menuToggle.setAttribute('aria-expanded','false');menuToggle.setAttribute('aria-label','Open menu');}
function closeSearch(){searchPanel.hidden=true;searchToggle.setAttribute('aria-expanded','false');}
menuToggle.addEventListener('click',()=>{const open=mobileNav.hidden;closeSearch();mobileNav.hidden=!open;menuToggle.setAttribute('aria-expanded',String(open));menuToggle.setAttribute('aria-label',open?'Close menu':'Open menu');});
mobileNav.addEventListener('click',event=>{if(event.target.closest('a'))closeMenu();});
searchToggle.addEventListener('click',()=>{const open=searchPanel.hidden;closeMenu();searchPanel.hidden=!open;searchToggle.setAttribute('aria-expanded',String(open));if(open){searchInput.focus();}});
document.querySelector('#search-close').addEventListener('click',()=>{closeSearch();searchToggle.focus();});

document.addEventListener('keydown',event=>{if(event.key==='Escape'){if(!searchPanel.hidden){closeSearch();searchToggle.focus();}else if(!mobileNav.hidden){closeMenu();menuToggle.focus();}}});

const deliveryNotice = document.querySelector('#delivery-notice');
const deliveryNoticeOpen = document.querySelector('#delivery-notice-open');
if (deliveryNotice && deliveryNoticeOpen) {
 const deliveryNoticeClose = deliveryNotice.querySelector('.delivery-notice-close');
 let deliveryPreviousFocus;
 const openDeliveryNotice = () => {
  deliveryPreviousFocus = document.activeElement;
  deliveryNotice.hidden = false;
  deliveryNoticeOpen.setAttribute('aria-expanded', 'true');
  document.body.classList.add('delivery-notice-open');
  deliveryNoticeClose.focus();
 };
 const closeDeliveryNotice = () => {
  deliveryNotice.hidden = true;
  deliveryNoticeOpen.setAttribute('aria-expanded', 'false');
  document.body.classList.remove('delivery-notice-open');
  deliveryPreviousFocus?.focus();
 };
 deliveryNoticeOpen.addEventListener('click', openDeliveryNotice);
 deliveryNotice.querySelectorAll('[data-delivery-close]').forEach(button=>button.addEventListener('click', closeDeliveryNotice));
 deliveryNotice.addEventListener('keydown', event=>{
  if (event.key === 'Escape') closeDeliveryNotice();
  if (event.key === 'Tab') {
   event.preventDefault();
   deliveryNoticeClose.focus();
  }
 });
}

const videoSearch = document.querySelector('#video-search');
if (videoSearch) {
 const categoryFilter = document.querySelector('#video-category');
 const cards = [...document.querySelectorAll('.video-card')];
 function filterVideos() {
  const query = videoSearch.value.trim().toLowerCase();
  const category = categoryFilter.value;
  let count = 0;
  for (const card of cards) {
   const matches = (!query || card.textContent.toLowerCase().includes(query)) && (!category || card.dataset.category === category);
   card.hidden = !matches;
   if (matches) count++;
  }
  document.querySelector('#video-count').textContent = count + (count === 1 ? ' installation guide' : ' installation guides');
  document.querySelector('#video-empty').hidden = count > 0;
 }
 videoSearch.addEventListener('input', filterVideos);
 categoryFilter.addEventListener('change', filterVideos);
}
